import React, { FC, useEffect, useState } from "react"
import { useSelector } from "react-redux"

import {
  canEdit,
  canEditActiveBid,
  getFormsEditable,
  getSectionFieldNames,
  getSectionSettings,
  getSettings,
  isBidUnderReview,
} from "@/onboarding/features/product/selectors"
import { ReservedSections } from "@/onboarding/features/product/models/Product"
import Edit from "./overview/Edit"
import Content from "./overview/Content"
import EditIcon from "../shared/EditIcon"

const Overview: FC = () => {
  const section = useSelector(getSectionSettings(ReservedSections.TOUR_STOPS))
  const canEditProduct = useSelector(canEdit)
  const canEditBid = useSelector(canEditActiveBid)
  const underReview = useSelector(isBidUnderReview)
  // The owning operator can edit their REQUESTED/DRAFT bid (canEditBid). Otherwise
  // defer to product/section editability, EXCEPT while a submitted bid is under
  // review — section.writeable is true for a CL owner on tour_stops regardless of
  // bid state and must not expose edit controls (meeting location/times) on the
  // submission. Contracting/contracted tours have no submitted bid in context.
  const editable = canEditBid || (!underReview && (canEditProduct || section?.writeable === true))
  const formsEditable = useSelector(getFormsEditable)
  const editingInitialState = formsEditable
  const showEditIcon = editable
  const [editing, setEditing] = useState(editingInitialState)

  const fieldNames = useSelector(getSectionFieldNames.tourLocation)
  const fieldsSettings = useSelector(getSettings(...fieldNames))
  const hasChangedFields = fieldNames.some((fieldName) => fieldsSettings[fieldName]?.changed)
  const labelStyle = hasChangedFields ? "yellow-underline" : ""

  const [showPrevious, setShowPrevious] = useState(false)

  const toggleShowPrevious = () => {
    if (hasChangedFields) {
      setShowPrevious((prev) => !prev)
    }
  }

  useEffect(() => {
    if (editing !== formsEditable) {
      setEditing(formsEditable)
    }
  }, [formsEditable])

  return (
    <div>
      <div className="d-flex justify-content-between">
        <div className="d-flex align-items-end gap-1">
          <h3 className="h5 mb-0" onClick={toggleShowPrevious}>
            Overview
          </h3>
          {showPrevious && <small className="text-muted fst-italic">Showing Original Values</small>}
        </div>
        {showEditIcon && !editing && <EditIcon onEdit={() => setEditing(true)} />}
        {editing && (
          <span className="cursor-pointer" onClick={() => setEditing(false)}>
            <i className="fas fa-times text-danger" />
          </span>
        )}
      </div>
      {editing ? <Edit setEditing={setEditing} /> : <Content />}
    </div>
  )
}

export default Overview
